import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Statistic, PageHeader, Button, Row, Col } from 'antd';
import Pusher from 'pusher-js/with-encryption';
import Capital from './StateComponents/Capital';
import PublicArea from './StateComponents/Public';
import StaffArea from './StateComponents/Staff';

const StateDashboard = () => {

    //1519
    let { account_id } = useParams();

    if (account_id !== "1519") {
        window.location.href = 'https://doortally.com';
    }

    console.log("LOADING MAIN VIEW")

    const [occupancy, setOccupancy] = useState(
        {
            capitol: {
                current_occupancy: 0,
                daily_entrances: 0,
            },
            public: {
                current_occupancy: 0,
                daily_entrances: 0,
            },
            staff: {
                current_occupancy: 0,
                daily_entrances: 0,
            },
        }
    )

    useEffect(() => {
        let account_id = "1519"
        axios({
            "method": "GET",
            "url": `https://app.doortally.com/api/v1/live/custom/california/${account_id}`,
        })
            .then((response) => {
                console.log(response.data.Data);
                setOccupancy(response.data.Data);
            })
            .catch((error) => {
                console.log(error)
            })
        // eslint-disable-next-line
    }, []); 

    useEffect(() => { 
        const loadData = () => {
            let account_id = "1519"
            axios({
                "method": "GET",
                "url": `https://app.doortally.com/api/v1/live/custom/california/${account_id}`,
            })
                .then((response) => {
                    console.log(response.data.Data);
                    setOccupancy(response.data.Data);
                })
                .catch((error) => {
                    console.log(error)
                })
        } 
        const interval = setInterval(() => {
            loadData(); 
        }, 60000);
        return () => clearInterval(interval);
      }, [occupancy]); 
/*
    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, []);
    */
 

     
 
    

    /*
    const pusher = new Pusher('f85be25299cbc5971d25', {
        cluster: 'us3',
    });
    const capitol_channel = pusher.subscribe('198');

    capitol_channel.bind('occupancy_change', function (data) {
        console.log('occupancy change')
        console.log(data.message) 

        setOccupancy(prevState => ({ ...prevState, capitol: {
            current_occupancy: 0,
            daily_entrances: 0,
        } }))
        
    }); 
*/
    /*
    const pusher = new Pusher('f85be25299cbc5971d25', {
        cluster: 'us3',
    });
     
    const capitol_channel = pusher.subscribe('198');
    const public_area_channel = pusher.subscribe('203');
    const staff_area_channel = pusher.subscribe('204');
 
    
    capitol_channel.bind('occupancy_change', function (data) {
        console.log('occupancy change')
        console.log(data.message)
        console.log(data.message.current_occupancy)
        setBuildingCount({
            current_occupancy: data.message.current_occupancy,
            total_visits: data.message.daily_entrances,
        });
    }); 
    public_area_channel.bind('occupancy_change', function (data) {
        console.log('occupancy change')
        console.log(data.message)
        console.log(data.message.current_occupancy)
        setPublicCount({
            current_occupancy: data.message.current_occupancy,
            total_visits: data.message.daily_entrances,
        });
    }); 
    staff_area_channel.bind('occupancy_change', function (data) {
        console.log('occupancy change')
        console.log(data.message)
        console.log(data.message.current_occupancy)
        setStaffCount({
            current_occupancy: data.message.current_occupancy,
            total_visits: data.message.daily_entrances,
        });
    });
     
    */



    return (
        <>
            <div className="container"> 
                <Capital occupancy={occupancy.capitol} />
                <PublicArea occupancy={occupancy.public} />
                <StaffArea occupancy={occupancy.staff} /> 
            </div>
        </>
    );
};

export default StateDashboard;